/**
 * Layout hero component
 * 
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Hero extends PureComponent {

	static propTypes = {
		
		children: PropTypes.node,
	}

	render() {
		
		const { children, layout, style } = this.props;
		
		const design = style === undefined || style === null ? '' : ' hero-' + layout + '-' + style.toLowerCase();
		const classes = layout !== undefined ? 'hero hero-' + layout + '' + design : 'hero';

		if (layout === 'bubble') {

			return (
			
				<aside className={classes}>
					<div className="container">

						<div className="hero-bubble-canvas">
							<div className="bubble bubble-lt"></div>
							<div className="bubble bubble-lb"></div>
							<div className="bubble bubble-rt"></div>
							<div className="bubble bubble-rb"></div>
						</div>

                    </div>
				</aside>
			)
		}
		else {

			return (
			
				<aside className={classes}>
					<div className="container">
						
						{children}

						<div className="hero-canvas">
							<div className="bubble bubble-lt"></div>
							<div className="bubble bubble-lb"></div>
							<div className="bubble bubble-rt"></div>
							<div className="bubble bubble-rb"></div>
						</div>

					</div>
				</aside>
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/hero/hero.js